import React, { Component } from 'react';
import Sound from '../UI/Sound';
import {isEmpty} from '@lsgo/lsgo-common/utils';
import { pickRandom } from '@lsgo/lsgo-common';

import happy_dragon from '../../assets/images/student/happy_dragon.gif';
import happy_sun from '../../assets/images/student/happy_sun.gif';
import happy_fish from '../../assets/images/student/happy_fish.gif';
import withActivityAnalytics from '../../hoc/WithActivityAnalytics';
import { TYPES } from '../../constants/activityTypes';

class QuizSingleAnswer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentAnswer: null,
            celebrationImage: null,
            showResults: false,
            skip: false,
            tries: 0,
            submitClicked: false,
            isSubmitting: false,
        };

        const { demoMode } = this.props;

        this.handleAnswerClick = this.handleAnswerClick.bind(this);
    }

    handleAnswerClick(choice) {
        //set toggle behavior
        const { currentAnswer } = this.state;

        const stateObject = {
            tries: this.state.tries + 1,
        };

        if (currentAnswer === choice.id) {
            Object.assign(stateObject, {
                currentAnswer: null,
            });
        } else {
            Object.assign(stateObject, {
                currentAnswer: choice.id,
            });
        }

        this.setState(stateObject);
    }

    handleSubmit = () => {
        const { currentAnswer, tries, submitClicked } = this.state;
        const { correct } = this.props;
        let timeout = 5000;

        //check if the student tried at least once
        if (tries === 0) {
            this.props.dispatchAddAlert('Have a try');

            if (!submitClicked) {
                this.setState({
                    submitClicked: true,
                });
            }
            // this.setState({
            //    tries: this.state.tries + 1
            // });
            return false;
        }

        //01. show results,
        this.setState({
            showResults: true,
            isSubmitting: true,
        });

        //02.check if the answer is correct
        const isCorrect = currentAnswer === correct;

        if (isCorrect) {
            this.setState({
                celebrationImage: pickRandom([happy_sun, happy_fish, happy_dragon]),
            });
            this.props.dispatchAddToScore('brain', 1);
            timeout = 3000;
        }

        const endTime = this.props.endTime();
        const { startTime, activityId } = this.props;

        const resultObj = {
            correct: isCorrect ? 1 : 0,
            answer: this.state.currentAnswer,
        };

        this.props.pushActivityAnalytics(startTime, endTime, TYPES.QUIZ_MULTI_SINGLE.ID, activityId, resultObj);

        setTimeout(() => {
            this.props.activityDone();
            this.setState({
                isSubmitting: false,
            });
        }, timeout);
    };

    renderChoices() {
        const { choices, correct } = this.props;

        const { showResults, currentAnswer } = this.state;

        return choices.map((choice, i) => {
            const style = {};

            if (choice.image) {
                Object.assign(style, {
                    backgroundImage: `url(${choice.image})`,
                });
            }

            if (choice.color) {
                Object.assign(style, {
                    backgroundColor: choice.color,
                });
            }

            const choiceClass = [];

            if (currentAnswer === choice.id) {
                choiceClass.push('shadow-dr');
            }

            if (showResults && correct === choice.id) {
                choiceClass.push('answer-correct');
            }

            if (showResults && correct !== choice.id) {
                choiceClass.push('answer-in-correct');
            }

            return (
                <div
                    key={choice.id}
                    className={`answer-container ${choiceClass.join(' ')}`}
                    style={style}
                    onClick={this.handleAnswerClick.bind(this, choice)}
                >
                    <div className='answer-inner-indicate'>
                        <i className='material-icons' style={{ color: '#7b7', fontSize: 42 }}>
                            {'check'}
                        </i>
                    </div>
                    <div className='quiz-answer'>{!choice.image && choice.title && choice.title}</div>
                    {'sound' in choice && !isEmpty(choice.sound) && <Sound audioUrl={choice.sound} />}
                </div>
            );
        });
    }

    render() {
        const { question, questionImage, questionSound, demoMode } = this.props;
        const { celebrationImage, submitClicked, isSubmitting } = this.state;

        const choices = this.renderChoices();

        return (
            <div className='quiz-wrapper'>
                <div className='quiz-content'>
                    <div className='quiz-question'>
                        <h3>{question}</h3>
                        {questionSound && <Sound audioUrl={questionSound} />}
                        {questionImage && (
                            <div className='quiz-question-img'>
                                <img alt={question} src={questionImage} />
                            </div>
                        )}
                    </div>
                    <div className='quiz-answers'>{choices}</div>
                    <div className='clearfix'></div>
                </div>

                {!demoMode && (
                    <div
                        style={{
                            marginBottom: 10,
                            marginTop: 15,
                            display: 'flex',
                            justifyContent: 'flex-end',
                        }}
                    >
                        {isSubmitting && (
                            <div className='lds-ellipsis'>
                                <div />
                                <div />
                                <div />
                                <div />
                            </div>
                        )}
                        <button
                            onClick={this.handleSubmit.bind(this)}
                            className='student-submit-btn'
                            disabled={isSubmitting || (submitClicked && this.state.currentAnswer === null)}
                        >
                            SUBMIT
                        </button>
                    </div>
                )}
                {celebrationImage && (
                    <div className='celebrationImage'>
                        <img alt='' style={{ marginTop: 100 }} width={300} height={300} src={celebrationImage} />
                    </div>
                )}
            </div>
        );
    }
}

export default withActivityAnalytics(QuizSingleAnswer);
